export const SET_SELECT_PAGE_SELECT_DATA_SOURCE = 'SET_SELECT_PAGE_SELECT_DATA_SOURCE';
export const SET_SELECT_PAGE_SELECT_2_DATA_SOURCE = 'SET_SELECT_PAGE_SELECT_2_DATA_SOURCE';
export const SET_SELECT_PAGE_SELECT_3_DATA_SOURCE = 'SET_SELECT_PAGE_SELECT_3_DATA_SOURCE';


export const SET_SELECT_OPTIMIZED_PAGE_SELECT_DATA_SOURCE = 'SET_SELECT_OPTIMIZED_PAGE_SELECT_DATA_SOURCE';
export const SET_SELECT_OPTIMIZED_PAGE_SELECT_2_DATA_SOURCE = 'SET_SELECT_OPTIMIZED_PAGE_SELECT_2_DATA_SOURCE';
export const SET_SELECT_OPTIMIZED_PAGE_SELECT_3_DATA_SOURCE = 'SET_SELECT_OPTIMIZED_PAGE_SELECT_3_DATA_SOURCE';


export const SET_CHECKBOX_PAGE_CHECKBOX_DATA_SOURCE = 'SET_CHECKBOX_PAGE_CHECKBOX_DATA_SOURCE';
export const SET_CHECKBOX_PAGE_CHECKBOX_2_DATA_SOURCE = 'SET_CHECKBOX_PAGE_CHECKBOX_2_DATA_SOURCE';


export const SET_CHECKBOX_OPTIMIZED_PAGE_CHECKBOX_DATA_SOURCE = 'SET_CHECKBOX_OPTIMIZED_PAGE_CHECKBOX_DATA_SOURCE';
export const SET_CHECKBOX_OPTIMIZED_PAGE_CHECKBOX_2_DATA_SOURCE = 'SET_CHECKBOX_OPTIMIZED_PAGE_CHECKBOX_2_DATA_SOURCE';


export const SET_TAG_PAGE_TAG_DATA_SOURCE = 'SET_TAG_PAGE_TAG_DATA_SOURCE';
export const SET_TAG_PAGE_TAG_2_DATA_SOURCE = 'SET_TAG_PAGE_TAG_2_DATA_SOURCE';


export const SET_TAG_OPTIMIZED_PAGE_TAG_DATA_SOURCE = 'SET_TAG_OPTIMIZED_PAGE_TAG_DATA_SOURCE';
export const SET_TAG_OPTIMIZED_PAGE_TAG_2_DATA_SOURCE = 'SET_TAG_OPTIMIZED_PAGE_TAG_2_DATA_SOURCE';



// WEBPACK FOOTER //
// ./app/scripts/constants/index.js